import React, { FC, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from "chart.js";
import { Line } from "react-chartjs-2";
import { RootState } from "../../store";
import { connect, ConnectedProps } from "react-redux";
import { ChartData, ChartZoom } from "../../store/chart/types";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const mapState = (state: RootState) => ({
  chartZoom: state.chart.chartZoom,
  data: state.chart.data,
  dayData: state.chart.dayData
});

const mapDispatch = {
  setData: () => ({ data: {} as ChartData }),
  setDayData: () => ({ dayData: {} as ChartData }),
  setChartZoom: () => ({ chartZoom: {} as ChartZoom }),
};

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & { data: ChartData, dayData: ChartData, chartZoom: ChartZoom };

const DailyLine: FC<Props> = (props: Props) => {
  let displayedData: number[] = [];
  let displayedLabels: string[] = [];
  if(props.chartZoom.dailyLine === "day") {
    displayedData = props.dayData.dayAccumPnl;
    displayedLabels = props.dayData.dayDates;
  } else if (props.chartZoom.dailyLine === "week") {
    displayedData = props.data.weekAccumPnl;
    displayedLabels = props.data.weekDates;
  } else if (props.chartZoom.dailyLine === "month") {
    displayedData = props.data.monthAccumPnl;
    displayedLabels = props.data.monthDates;
  }


  const options = {
    interaction: {
        intersect: false,
        mode: 'index',
      },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top" as const,
        labels: { color: "#FFFFFF" },
        display: false,
      },
      title: {
        display: false,
        text: "Cumlulative P&L",
        color: "#FFFFFF",
        position: "top",
        align: "start",
        padding: 10,
        font: {
          family: "'Poppins', sans-serif",
          size: 15, 
          weight: '400'
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#FFFFFF",
          font: {
            family: "'Poppins', sans-serif",
            size: 8
          },
        },
        grid: {
          color: "rgb(255, 255, 255, 0)",
        },
      },
      y: {
        ticks: {
          color: "#FFFFFF",
          font: {
            family: "'Poppins', sans-serif",
            size: 8
          },
        },
        grid: {
          color: "rgb(255, 255, 255, 0.1)",
        },
      },
    },
  };

  const labels = displayedLabels;

  const data = {
    labels,
    datasets: [
      {
        label: "P&L", // label at top of chart
        data: displayedData, // actual data points
        borderColor: "rgba(0, 140, 236, 1)", // color of the line
        backgroundColor: "rgba(0, 140, 236, 0.3)",
        pointBackgroundColor: "rgba(255, 255, 255, 1)", // fill color of label
        pointRadius: 2,
        fill: true,
        tension: 0.2
        //cubicInterpolationMode: "monotone",
      },
    ],
  };


  return (
    <div className="w-full h-full">
      {/* @ts-ignore */}
      <Line options={options} data={data} />
    </div>
  );
};

export default connector(DailyLine);
